import React from 'react';

import { useDropzone } from 'react-dropzone';
import classNames from 'classnames';

import { PinIcon } from 'components/Icons';

import DropzoneWidgetArea from './DropzoneWidgetArea';

import styles from './DropzoneWidget.module.scss';

interface DropzoneProps {
  extensions: string[];
  maxFileSize?: number;
  uploadFileTitle?: string;
  dragAndDropTitle?: string;
  onDragClass?: string;
  handleFiles: (files: File[]) => void;
}

export interface DropzoneFile {
  file: File;
  key: string;
  blobLink: string;
}

const DEFAULT_MAX_FILE_SIZE = 10485760;

const DropzoneWidget = ({ extensions, handleFiles, maxFileSize = DEFAULT_MAX_FILE_SIZE }: DropzoneProps) => {
  const { open, getRootProps, getInputProps, isDragAccept, isDragActive, isDragReject } = useDropzone({
    accept: extensions,
    noClick: true,
    multiple: true,
    maxSize: maxFileSize,
    onDrop: (acceptedFiles: File[]) => {
      handleFiles(acceptedFiles);
    },
  });

  return (
    <div className={styles.widget_container}>
      <div className={styles.widget} {...getRootProps()}>
        <input className={styles.upload_input} {...getInputProps()} />
        <div className={classNames(styles.dropbox, {})}>
          <p className={styles.text_container}>
            <PinIcon className={styles.pin_icon} />
            <span className={styles.link} onClick={open}>
              Add file
            </span>
            <span className={styles.description}>&nbsp;or drop it right here</span>
          </p>
          <DropzoneWidgetArea
            className={classNames(styles.dropbox_background, {
              [styles.dropbox_accept]: isDragAccept,
              [styles.dropbox_active]: isDragActive,
              [styles.dropbox_reject]: isDragReject,
            })}
          />
        </div>
      </div>
    </div>
  );
};

export default DropzoneWidget;
